import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getPlan, updatePlan } from '../api/plan';
import RegistarLayout from '../components/RegistarLayout';
import InputFormLayout from '../components/InputFormLayout';
import RegistarButtonLayout from '../components/RegistarButtonLayout';
import './PlanRegistar.css';

export default function PlanEditPage() {
  const { companyId, planId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || `企業ID: ${companyId}`;
  const navigate = useNavigate();

  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  // フォーム状態
  const [name, setName] = useState('');
  const [amount, setAmount] = useState('');
  const [trialDays, setTrialDays] = useState('');

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPlanData = async () => {
      try {
        const res = await getPlan(planId);
        const planData = res.plan;
        setPlan(planData);
        setName(planData.name || '');
        setAmount(planData.amount || '');
        setTrialDays(String(planData.trial_days || 0));
      } catch (err) {
        console.error('プラン情報の取得に失敗:', err);
        setError('プラン情報の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };
    fetchPlanData();
  }, [planId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // 確認ダイアログ
    if (!window.confirm('編集内容を保存します。よろしいですか？')) {
      return;
    }

    try {
      const payload = {
        name,
        amount: parseInt(amount),
      };

      // サブスクリプションの場合はtrial_daysを送信
      if (plan.interval === 'month') {
        payload.trial_days = parseInt(trialDays);
      }

      await updatePlan(planId, payload);
      setMessage('プランを更新しました！');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'プラン更新に失敗しました');
    }
  };

  if (loading) {
    return (
      <RegistarLayout title="プラン編集" margin="0 auto" marginTop="15vh">
        <div>読み込み中...</div>
      </RegistarLayout>
    );
  }

  if (!plan) {
    return (
      <RegistarLayout title="プラン編集" margin="0 auto" marginTop="15vh">
        <div style={{ color: 'red' }}>プランが見つかりません</div>
      </RegistarLayout>
    );
  }

  const intervalLabel = plan.interval === 'one_time' ? '一括払い' : 'サブスクリプション';

  return (
    <RegistarLayout title="プラン編集" margin="0 auto" marginTop="15vh">
      {message && <div style={{ color: 'green', marginBottom: '10px' }}>{message}</div>}
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}

      <div className="planElement">
        <InputFormLayout
          id="planName"
          labelTitle="プラン名"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder=""
        />

        <InputFormLayout
          id="amount"
          labelTitle="金額（円）"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder=""
        />

        {/* クーポン: 表示のみ（グレーアウト） */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ color: '#333', display: 'block', marginBottom: '5px' }}>
            クーポン
          </label>
          <input
            type="text"
            value={plan.promotion_code || 'なし'}
            disabled
            style={{
              width: '100%',
              padding: '0.7rem 1rem',
              fontSize: '1rem',
              border: '1.5px solid #ccc',
              borderRadius: '6px',
              backgroundColor: '#e9ecef',
              color: '#6c757d',
            }}
          />
        </div>

        {/* 課金タイプ: 表示のみ（グレーアウト） */}
        <div style={{ marginBottom: '10px' }}>
          <label style={{ color: '#333', display: 'block', marginBottom: '5px' }}>
            課金タイプ
          </label>
          <input
            type="text"
            value={intervalLabel}
            disabled
            style={{
              width: '100%',
              padding: '0.7rem 1rem',
              fontSize: '1rem',
              border: '1.5px solid #ccc',
              borderRadius: '6px',
              backgroundColor: '#e9ecef',
              color: '#6c757d',
            }}
          />
        </div>

        {/* 無料トライアル日数: サブスクリプションの場合のみ表示 */}
        {plan.interval === 'month' && (
          <div style={{ marginBottom: '10px' }}>
            <label style={{ color: '#333', display: 'block', marginBottom: '5px' }}>
              無料トライアル日数
            </label>
            <input
              type="number"
              value={trialDays}
              onChange={(e) => setTrialDays(e.target.value)}
              min="0"
              style={{
                width: '100%',
                padding: '0.7rem 1rem',
                fontSize: '1rem',
                border: '1.5px solid #ccc',
                borderRadius: '6px',
                backgroundColor: '#fff',
                color: '#333',
              }}
            />
          </div>
        )}

        <div className="planRegisterButtons">
          <RegistarButtonLayout
            buttonTitle="更新"
            type="submit"
            onClick={handleSubmit}
          />
          <RegistarButtonLayout
            buttonTitle="プラン一覧に戻る"
            type="button"
            onClick={() =>
              navigate(`/plans/${companyId}?companyName=${encodeURIComponent(companyName)}`)
            }
          />
        </div>
      </div>
    </RegistarLayout>
  );
}
